import { epagAPI } from '../API/epagAPI'
import { emptyProfile } from '../components/ViewProfile/emptyProfile'

export const fetchRolesAndPermissions = async (token, setUserPermissions, setPermissionsQuantity) => {
  const userPermissions = await epagAPI.GetUserPermissions(token).catch((error) => {
    console.error(error.message)
  })

  const maxPermissionsAmount = await epagAPI.GetMaxPermissionsAmount(token).catch((error) => {
    console.error(error.message)
  })

  setUserPermissions(userPermissions)
  setPermissionsQuantity(maxPermissionsAmount)
}

export const requestProfile = async (
  token,
  setUserProfile,
  setUserPermissions,
  setPermissionsQuantity,
  setIsLoadingProfile,
  setFetchProfileError
) => {
  if (!token) return

  try {
    const answer = await epagAPI.GetOwnProfile(token)

    if (setUserProfile) {
      if (answer) {
        setUserProfile(answer)
        await fetchRolesAndPermissions(token, setUserPermissions, setPermissionsQuantity)
      } else {
        setUserProfile(emptyProfile)
      }
    }

    return answer
  } catch (error) {
    setUserProfile && setUserProfile(null)
    setFetchProfileError && setFetchProfileError(error.message)
    throw new Error(error.message)
  } finally {
    setIsLoadingProfile && setIsLoadingProfile(false)
  }
}
